<template>
  <div class="page_body">
    <div style="margin-bottom: 20px; font-weight: 800">
          <span
            ><el-checkbox v-model="checkedAll" @change="changeAllChecked()"
              >全选</el-checkbox
            ></span
          >
        </div>
    <div v-for="(item, index) in viewArr" :key="index" class="row">
      <p style="margin-bottom: 20px; font-weight: 800">{{ item.name }}</p>
      <!-- <template v-if="item.key === 'A'">
        <el-radio
          v-model="radioCheck"
          :label="child_item.id"
          v-for="(child_item, child_index) in item.children"
          :key="child_index"
          @change="getValue"
          >{{ child_item.name }}</el-radio
        >
      </template> -->
      <template>
        <div style="margin-top: 20px">
          <!-- <span><el-checkbox v-model="checked">全选</el-checkbox></span> -->
          <div style="margin-top: 10px" class="row_child">
            <el-checkbox
              v-for="(child_item, child_index) in item.children"
              :key="child_index"
              v-model="child_item.check"
              :label="child_item.name"
              @change="checkBoxChange()"
            ></el-checkbox>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pc",
  props: ["pageInfo", "permission", "type"],
  data() {
    return {
      listArr: [
        {
          name: "登录权限",
          key: "A",
        },
        {
          name: "设备管理",
          key: "B",
        },
        {
          name: "分级管理",
          key: "C",
        },
        {
          name: "订单管理",
          key: "D",
        },
         {
          name: "商品管理",
          key: "E",
        },
         {
          name: "分账管理",
          key: "F",
        },
         {
          name: "营销管理",
          key: "G",
        },
         {
          name: "财务管理",
          key: "H",
        },
         {
          name: "用户管理",
          key: "I",
        },
         {
          name: "会员管理",
          key: "J",
        },
         {
          name: "数据分析",
          key: "K",
        },
         {
          name: "报表管理",
          key: "L",
        },
         {
          name: "系统设置",
          key: "M",
        },
      ],
      viewArr: [],
      radioCheck: "",
      checkedAll: false,
    };
  },
  created() {
      console.log("log")
  },
  watch: {
    type: {
      handler(value) {
          console.log(value)
        this.getNewArrList();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getNewArrList() {
        console.log(this.permission)
        console.log( this.pageInfo)
      this.pageInfo.forEach((item) => {
        item.check = false;
        let has_id = this.permission.find(
          (permission_item) => Number(permission_item) === item.id
        );
        if (has_id) {
          item.check = true;
          // if (item.sort_sequence === "A") {
          //   this.radioCheck = item.id;
          // }
        }
        let names = this.listArr.find((key) => key.key === item.sort_sequence);
        let obj = {
          name: names.name,
          key: names.key,
          children: [],
        };
        let has = this.viewArr.findIndex((value) => value.name === names.name);
        if (has > -1) {
          let child_has = this.viewArr[has].children.find(
            (has_item) => has_item.id === item.id
          );
          if (!child_has) {
            this.viewArr[has].children.push(item);
          }
        } else {
          obj.children.push(item);
          this.viewArr.push(obj);
        }
      });
      this.getAllCheckType();
    },
     getAllCheckType() {
      let arr = [];
      this.viewArr.forEach(item => {
          item.children.forEach(child_item => {
              if (child_item.check) {
                  arr.push(child_item.id)
              }
          })
      })
      this.checkedAll = arr.length === this.pageInfo.length
    },
    // getValue(e) {
    //   this.radioCheck = e;
    //   let obj = this.viewArr.find((item) => item.key === "A");
    //   obj.children.forEach((item) => {
    //     if (item.id !== e) {
    //       item.check = false;
    //     } else {
    //       item.check = true;
    //     }
    //   });
    // },
    changeAllChecked() {
      this.checkedAll = !!this.checkedAll;
      console.log(this.checkedAll);
      this.viewArr.forEach((item) => {
        if (item.key) {
          item.children.forEach((child_item) => {
            child_item.check = this.checkedAll;
          });
        }
      });
    },
    checkBoxChange() {
       this.$forceUpdate();
       this.getAllCheckType();
    },
    getAllCheck() {
      let arr = [];
      console.log(this.viewArr);
      this.viewArr.forEach(item => {
          item.children.forEach(child_item => {
              if (child_item.check) {
                  arr.push(child_item.id)
              }
          })
      })
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.page_body {
  width: 100%;
  .row {
    margin-bottom: 20px;
    .row_child {
      .el-checkbox {
        display: inline-block;
        margin-left: 0;
        width: 25%;
      }
    }
  }
}
</style>
